class Animation {
  constructor() {
    this.animatedBlocks = document.querySelectorAll('[data-animated-block]');
    this.timeout;
  }

  init() {
    this.animateBlocks();

    window.addEventListener('scroll', () => {
      if (this.timeout) {
        window.cancelAnimationFrame(this.timeout);
      }

      this.timeout = window.requestAnimationFrame(() => {
        this.animateBlocks();
      });
    });
  }

  animateBlocks() {
    for (let animatedBlock of this.animatedBlocks) {
      if (
        this.isElementInViewport(animatedBlock) &&
        !animatedBlock.classList.contains('js-animation-complete')
      ) {
        const isHero = animatedBlock.classList.contains('hero');
        const animatedElements = animatedBlock.querySelectorAll(
          '[data-animate]'
        );
        setTimeout(
          () => {
            for (let i = 0; i < animatedElements.length; i++) {
              setTimeout(() => {
                animatedElements[i].classList.add('js-fade-in');
              }, i * 400);
            }
          },
          isHero ? 1000 : 0
        );

        animatedBlock.classList.add('js-animation-complete');
      }
    }
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();

    // if the element is bigger than the viewport, show the element a third of the way down the viewport height
    let showHeight = el.clientHeight / 2;
    if (showHeight > window.innerHeight) {
      showHeight = window.innerHeight / 2;
    }

    return (
      rect.top -
        (window.innerHeight || document.documentElement.clientHeight) <=
      -showHeight
    );
  }
}

export default Animation;
